import { render } from "./ServicesListView.vue?vue&type=template&id=77642fe6"
import script from "./ServicesListView.vue?vue&type=script&lang=js"
export * from "./ServicesListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__